export default {
    SubmissionProgressBar: {
        details: 'Personal information',
        profPref: 'Business preferences',
        cvSend: 'Send resumé'
    },
    SubmissionFormStep1: {
        name: 'Name',
        surname: 'Surname',
        address: 'Address',
        city: 'City',
        state: 'State/Province',
        country: 'Country',
        phone: 'Phone',
        invalidNumber: 'Invalid phone number.',
        email: 'e-mail',
        gender: 'Gender',
        genderOptions: ['Male', 'Female'],
        birthday: 'Date of Birth',
        educationLevel: 'Level of education',
        professionalExperience: 'Years of professional experience'
    },
    SubmissionFormStep2: {
        department: 'Department',
        location: 'Location',
        departmentOptions: ['Marketing', 'Sales', 'Production', 'Finance', 'Accounting', 'R&D', 'Logistics', 'IT', 'Human Resources', 'Other'],
        departmentLocationOptions: ['Greece', 'United Kingdom', 'Bulgaria', 'Turkey', 'Other'],
        selected: 'selected',
        priorPositionExperience: 'Years of experience in a similar position',
        placeholder: 'None'
    },
    nextStep: {
        nextStep: 'next'
    },
    formHeader: {
        formHeaderStep1: 'Please fill in the fields below to apply for a job. Fields marked with an asterisk (*) are required.',
        formHeaderStep2: 'Please select the departments and locations that interest you. Fields marked with an asterisk (*) are required.',
        formHeaderStep3: 'Please fill in the fields below to apply for a job. Fields marked with an asterisk (*) are required.'
    },
    SubmissionFormStep3: {
        coverLetter: 'Cover letter',
        attachCV: 'Attach a resume',
        submitApplication: 'submit',
        bigFileSizeError: 'The file you submitted is over the allowed size (2MB)',
        description: ['File Type: pdf', 'File Size: 2MB']
    },
    gdprInfo: {
        title: 'Update for processing personal data:',
        body: ['We will consider the possibility of your employment in our Company, depending on your skills and our labor needs. We will keep your CV for a period up to two (2) years, in order to contact you in case any job opportunity comes up that is suitable for you. During this period, you may inform us of any completion in your CV, by re-submitting it, via our website (', 'www.karelia.gr', '). If you desire to be fully informed, before sending your CV you are advised to read the ', 'Privacy Policy', 'https://www.karelia.gr/en/privacy-policy/', '. In order to erase your CV and for any other issue related to personal data please contact ', 'dpo@karelia.gr']
    },
    errors: {
        emptyFieldError: 'Please fill this field',
        wrongEmailFieldError: 'Invalid Email',
        invalidWorkExperience: 'Work experience years are invalid',
        emptyCvError: 'Please attach your resume',
        somethingWentWrong: 'Please check that your file meets the above requirements'
    },
    footer: {
        siteInfo: 'The purpose of this site is to share information about our company and our expertise in tobacco products. It is not intended to market, promote or advertise any of our cigarette brands or tobacco products.'
    },
    hero: {
        title: 'Be part of our team'
    },
    successfulSubmission: 'Your resume was submitted successfully. Thank you for your interest.'
}